import React, { useMemo } from 'react';
import {
  generateDataForTree,
  useLoadTreeData,
} from '../../../../../shared/lib/treeAddressesUtils';
import { fieldNames } from '../../../common/config';
import { useQueryClient } from 'react-query';
import { shutdownCitiesQuery } from '../../../../../shared/api/queries';
import { Form, Spin } from 'antd';
import TreeCheck from '../../../../../../../components/TreeCheck';
import useAddressesTreeDataNew from '../../../../../shared/hooks/useAddressesTreeDataNew';
import useFlatsByCompany from '../../../changeAddresses/api/useFlats';

const { key: citiesKey } = shutdownCitiesQuery;
const addressesFieldName = fieldNames.addresses;
const cityFieldName = fieldNames.city;
const companyFieldName = fieldNames.company;
const FormItem = Form.Item;

const getLabelFromInitialValue = (initialValue) => {
  const name = initialValue.city?.name ? ` (${initialValue.city?.name})` : '';
  return `УК и адреса${name}`;
};

const getLabelByCityId = (cities, cityId) => {
  const cityName = cities?.find((city) => city.id === cityId)?.name;
  const name = cityName ? ` (${cityName})` : '';
  return `УК и адреса${name}`;
};

const AddressesField = ({ form, initialValue }) => {
  const queryClient = useQueryClient();

  const cityId = initialValue
    ? initialValue.alertCity?.id
    : form.getFieldValue(cityFieldName);
  const companyId = initialValue
    ? initialValue.serviceCompany?.id
    : form.getFieldValue(companyFieldName);

  const cities = queryClient.getQueryData(citiesKey(companyId));

  const { data: flats = {}, isFetching: isFetchingFlats } = useFlatsByCompany(
    companyId,
    {
      enabled: Boolean(companyId),
      select: (data) => {
        return Object.entries(data).reduce((acc, [key, value]) => {
          acc[key] = Array.isArray(value) ? value.map((item) => item.id) : [];

          return acc;
        }, {});
      },
    }
  );

  const init = useMemo(
    () =>
      generateDataForTree(
        initialValue,
        initialValue?.serviceCompany?.id,
        flats
      ),
    [initialValue, flats]
  );

  const { treeData, setTreeData, loading } = useAddressesTreeDataNew({
    cityId,
    enabled: initialValue ? true : Boolean(cityId && companyId),
    companyId,
  });

  const onLoadData = useLoadTreeData({ treeData, setTreeData, cityId });

  const isFetching = isFetchingFlats;

  return (
    <Spin spinning={isFetching}>
      <FormItem
        label={
          initialValue
            ? getLabelFromInitialValue(initialValue)
            : getLabelByCityId(cities, cityId)
        }
        style={{ margin: 0 }}
      >
        {form.getFieldDecorator(addressesFieldName, {
          trigger: 'onCheck',
          valuePropName: 'checkedKeys',
          rules: [{ required: true, message: 'Выберите адрес', type: 'array' }],
          initialValue: init.checkedKeys?.length ? init.checkedKeys : [],
        })(
          <TreeCheck
            treeData={treeData}
            loadData={onLoadData}
            loading={loading}
            checkable={true}
            // checkedKeys={init.checkedKeys}
            halfCheckedKeys={init.halfCheckedKeys}
          />
        )}
      </FormItem>
    </Spin>
  );
};

export default AddressesField;
